import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect, useRef } from "react";
import Dropdown from "./Dropdown";

const MenuItems = ({ items, depthLevel, showDivider }) => {
  const [dropdown, setDropdown] = useState(false);
  const navigate = useNavigate();
  
  let ref = useRef();
  
  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);
  
  const onMouseEnter = () => {
    window.innerWidth > 960 && setDropdown(true);
  };
  
  const onMouseLeave = () => {
    window.innerWidth > 960 && setDropdown(false);
  };
  
  const closeDropdown = (e) => {
    if (window.innerWidth > 960) {
      dropdown && setDropdown(false);
    } else {
      e.stopPropagation();
    }
  };
  
  const { location } = useSelector((state) => state.location);
  
  return (
    <li
      className={`menu-items lg:text-xs lg:mb-1 rounded-md flex items-center ${showDivider ? "after:content-[''] after:block after:w-px after:h-4 after:bg-[#6D758F]/50 after:ml-2" : ""}`}
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={closeDropdown}
    >
      <div className="w-full">
        {items.path && items.children ? (
          <>
            <button
              className="font-bold nav_link flex gap-2 items-center ml-2"
              type="button"
              aria-haspopup="menu"
              aria-expanded={dropdown ? "true" : "false"}
              onClick={() => {
                setDropdown((prev) => !prev);
                if (items?.path) {
                  navigate(items?.path);
                }
              }}
            >
              {window.innerWidth < 960 && depthLevel === 0 ? (
                <>
                  {items[location]}
                </>
              ) : (
                <h1>
                  {items[location]}
                </h1>
              )}
              {/*{depthLevel > 0 ? <span>&raquo;</span> : <span className="arrow" />}*/}
            </button>
            <Dropdown
              depthLevel={depthLevel}
              submenus={items.children}
              dropdown={dropdown}
            />
          </>
        ) : !items.path && items.children ? (
          <>
            <button
              type="button"
              aria-haspopup="menu"
              className="font-bold nav_link flex items-center gap-2"
              aria-expanded={dropdown ? "true" : "false"}
              onClick={(e) => {
                e.stopPropagation();
                setDropdown((prev) => !prev);
              }}
            >
              {items[location]}{" "}
              {/*{depthLevel > 0 ? <span>&raquo;</span> : <span className="arrow" />}*/}
            </button>
            <Dropdown
              depthLevel={depthLevel}
              submenus={items.children}
              dropdown={dropdown}
            />
          </>
        ) : items.href ? (
          <a
            className="font-bold nav_link flex items-center gap-2"
            target="_blank"
            title={
              location === "uz"
                ? items.title_uz
                : location === "ru"
                  ? items.title_ru
                  : items.title_en
            }
            href={items.href}
            rel="noreferrer"
          >
            {items[location]}
          </a>
        ) : (
          <NavLink className={`font-bold nav_link ml-2`} to={items.path}>
            {items[location]}
          </NavLink>
        )}
      </div>
    </li>
  );
};

export default MenuItems;
